// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueLazyload from 'vue-lazyload'
import 'swiper/dist/css/swiper.min.css'
import './assets/style/animation.scss'
import './assets/style/reset.scss'
import { stsEventCategory } from './utils/common'

Vue.config.productionTip = false
Vue.prototype.$bus = new Vue()
Vue.prototype.stsEventCategory = stsEventCategory
Vue.use(VueLazyload)

router.beforeEach((to, from, next) => {
  next()
})
router.afterEach((to, from) => {
  Vue.prototype.$bus.$emit('pathchanged', to.path)
})
router.onError(error => {
  Vue.prototype.$message({title: '错误', message: '页面加载失败，已经为您推荐到主页', type: 'error', offset: 50})
})
var app = new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js